export const SearchTypeEnum = {
    OfficialAreas: 1,
    ClientAreas : 2
};



// WEBPACK FOOTER //
// ./src/enuns/searchType.enum.js